package com.gastoncantera.intercom.push

actual fun dismissIncomingCallNotification() {
    // Web: sin notificación nativa de llamada.
}
